export enum GraphQLItemTypeEnum{
    unsupported = 'Unsupported',
    testCase = 'TestCase',
    testSuite = 'TestSuite',
    testAnalysis = 'TestAnalysis',
    specificationCoverage = 'SpecificationCoverage',
    softwareVersionCoverage = 'SoftwareVersionCoverage',
    testSpecification = 'TestSpecification'
}